import { defineMessages } from 'react-intl';

export default defineMessages({
  storeSetupPageTitle: {
    description: 'Settings > Store Setup > Title',
    defaultMessage: 'Store Setup',
    id: 'c75hjX',
  },
  storeSetupPageSubtext: {
    description: 'Subtext description of Store Setup',
    defaultMessage:
      'Connect an unlimited number of stores (including shopping carts, marketplaces, ERPs, etc) to begin importing your orders. Once connected, you can customize each store’s settings, including import frequency, email & packing slip branding, and much more. <a>Learn more about store settings</a>.',
    id: 'ympjeh',
  },
  storeGridTitle: {
    description: 'Stores grid title',
    defaultMessage: 'Stores',
    id: 'SWgbRS',
  },
  addNewStoreButtonText: {
    description: 'settings > Store Setup > add new store button',
    defaultMessage: 'Connect Store',
    id: '5tcEBa',
  },
  showInactiveStores: {
    description: 'settings.storesetup.inactiveStores',
    defaultMessage: 'Show Inactive Stores',
    id: 'C3g7N/',
  },
  activateEnhancedReturns: {
    description: 'settings.storesetup.activateEnhancedReturns',
    defaultMessage: 'Activate',
    id: 'LxhFzs',
  },
  storeFeatureGatedMessage: {
    description: 'message for custom store feature gated',
    defaultMessage: 'One or more connected store(s) is not supported with your current subscription. Upgrade your plan to reactivate.',
    id: 'f8GGsz',
  },
  storeFeatureGatedTitle: {
    description: 'title for custom store feature gated',
    defaultMessage: 'Connected store not supported',
    id: '+rP2RK',
  },
  customsStoreFeatureName: {
    description: 'feature name used in customs store feature upsell',
    defaultMessage: 'Custom Stores',
    id: 'ymFSKN',
  },
  externalStoresAccessFeatureName: {
    description: 'feature name used in external stores access feature upsell',
    defaultMessage: 'Selling Channels',
    id: 'SMzBX8',
  },
  additionalStoresFeatureName: {
    description: 'feature name used for additional stores access feature upsell',
    defaultMessage: 'Additional Stores',
    id: 'bFChWV',
  },
});
